import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "authenticated-tabs"
  static values = {
    authenticated: Boolean,
    reload: Boolean
  }

  connect() {
    super.connect()

    const authenticated = this.authenticatedValue
    const reload = this.reloadValue
    this.send("connect", { authenticated, reload })
  }
}
